import { SwitchProps } from "@origin-digital/ods-core";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";

export const usePageTitleSection = () => {
  const {
    context: { user },
  } = useAppContext();
  const isHomeUser = Boolean(user?.role === "USER" && !user.main_company);
  const navigate = useNavigate();
  const groupByProjectsSwitchProps: Partial<SwitchProps> = React.useMemo(() => {
    return {
      onChange: () => navigate("/"),
      "data-id": "pageTitleSection.groupByProjectsSwitch",
    };
  }, [navigate]);

  return { isHomeUser, groupByProjectsSwitchProps };
};
